<!-- 
  详情页 - 采购付款计划
  props:
    id: 详情id
 -->

<template>
  <div class="v-tabs pay-plan">
    <div class="content">
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="55">
        </el-table-column>
        <el-table-column
          property="payPlanNo"
          label="付款计划编号"
          width="180"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="amount"
          label="付款金额 (元)"
          width="120"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="statusStr"
          label="状态"
          width="90"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="others"
          label="其他"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="payType"
          label="付款类型"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="memo"
          label="付款说明"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      tableData: []
    }
  },
  methods: {
    getList () {
      let url = '/purchase/payPlanList.html'
      let params = {
        purchaseId: this.id
      }
      api.post(url, params, (data) => {
        this.tableData = data.payPlanList
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .content {
    padding-top: 10px;
  }
</style>


// WEBPACK FOOTER //
// pay-plan-list.vue?b30bbdd0